import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux"; 
import { NON_ERASABLE_INCIDENTTYPE_ID, ENDPOINT,LIMIT_PAGE } from "constants/variables";
import Box from '@mui/material/Box';   
import Button from '@mui/material/Button';  
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';  
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import TableSorting from "./SortingTables";
import PropTypes from 'prop-types';

const initialFilters= {
  "idFrom":"",
  "idTo":"",
  "codeFrom":"",
  "codeTo":"",
  "nameesFrom":"",
  "nameesTo":"",
  "nameenFrom":"",
  "nameenTo":"",
  "codeHexFrom":"",
  "codeHexTo":"",
  "codeCotGroupFrom":"",
	"codeCotGroupTo":"",
  "code_iso2From":"",
  "code_iso2To":"",
  "code_iso3From":"",
  "code_iso3To":"",
  "extphoneFrom":"",
  "extphoneTo":"",
  "extinternetFrom":"",
  "extinternetTo":"",
  "isEnabled":true,
  "isNotEnabled":true
};

const initialState = [{
  "id" : "",
  "code" : "",
  "namees" : "",
  "nameen" : ""
}];

const headCells = [
  {
    id: 'id',
    numeric: false,
    disablePadding: false,
    label: 'Text_Code',
    canOrder:true,
  },
  {
    id: 'code',
    numeric: false,
    disablePadding: false,
    label: 'Text_Code',
    canOrder:true,
  },
  {
    id: 'namees',
    numeric: false,
    disablePadding: false,
    label: 'Text_NameEs',
    canOrder:true,
  },
  {
    id: 'nameen',
    numeric: false,
    disablePadding: false,
    label: 'Text_NameEn',
    canOrder:true,
  }
];


const IncidentTypeSettings = ({showModalIncidentTypeSettings, setShowModalIncidentTypeSettings,setIndexShowSettings,setShowModalGeneralSettings,setShowModalEmployeeSettings,isEmployee,setShowModalStoreSettings,isStore,setShowModalFormSettings,isForm,setShowModalContractSettings,isContract,
  setShowModalRegisterBookSettings,
  isRegisterBook}) => {
  const { t } = useTranslation(['listDataGeneralSettings']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const [data, setData] = useState(initialState);
  const [form, setForm] = useState(initialState[0]);
  const [filters, setFilters] = useState(initialFilters);
  const [applyFilters, setApplyFilters] = useState(initialFilters);
  const [numTotReg, setNumTotReg] = useState(0);
  const [numTotRegFilter, setNumTotRegFilter] = useState(0);
  const [errorsFilters, setErrorsFilters] = useState({});
  const [errors, setErrors] = useState({});
  const [inputText, setInputText] = useState("");
  const [openCreateData, setOpenCreateData] = useState(false);
  const [openDeleteRow, setOpenDeleteRow] = useState(false);
  const [openEditRow, setOpenEditRow] = useState(false);
  const [openEditFilter, setOpenEditFilter] = useState(false);
  const [rowEdit, setRowEdit] = useState(initialState[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [idCodeDelete, setIdCodeDelete] = useState(DELETE_CODE);
  const dispatch = useDispatch();
  const [activeOffset, setActiveOffset] = useState(false);
  const [currencyOffset, setCurrencyOffset] = useState(0);
  const [rangeOffset, setRangeOffset] = useState([{}]);
  const [openCreateProvince,setOpenCreateProvince]=useState(false);  
 
  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && showModalIncidentTypeSettings) {
        setData(initialState);
        setForm(initialState[0]);
        setFilters(initialFilters);
        setApplyFilters(initialFilters);
        setNumTotReg(0);
        setNumTotRegFilter(0);
        setErrorsFilters({});
        setErrors({});
        setInputText("");
        setOpenCreateData(false);
        setOpenDeleteRow(false);
        setOpenEditRow(false);
        setOpenEditFilter(false);
        setRowEdit(initialState[0]);
        dispatch(setLoading(false));
        setIsLoadingError(false);
        setIdCodeDelete(DELETE_CODE);
        setActiveOffset(false);
        setCurrencyOffset(0);
        setOpenCreateProvince(openCreateProvince);
        setRangeOffset([{}]);
        setIndexShowSettings(0);
        setShowModalIncidentTypeSettings(false);
        setShowModalGeneralSettings(true);
        setShowModalEmployeeSettings(isEmployee);
        setShowModalStoreSettings(isStore);
        setShowModalFormSettings(isForm);
        setShowModalContractSettings(isContract);
        
        setShowModalRegisterBookSettings(isRegisterBook);
      }
    },
    [
      setData,
      setForm,
      setFilters,
      setApplyFilters,
      setNumTotReg,
      setNumTotRegFilter,
      setErrorsFilters,
      setErrors,
      setInputText,
      setOpenCreateData,
      setOpenDeleteRow,
      setOpenEditRow,
      setOpenEditFilter,
      setRowEdit, 
      setIsLoadingError,
      setIdCodeDelete,
      setActiveOffset,
      setCurrencyOffset,
      setRangeOffset,
      openCreateProvince,
      setOpenCreateProvince,
      showModalIncidentTypeSettings,
      setShowModalIncidentTypeSettings,
      setIndexShowSettings,
      setShowModalGeneralSettings,
      setShowModalEmployeeSettings,
      isEmployee,
      setShowModalStoreSettings,
      isStore,
      setShowModalFormSettings,
      isForm,
      setShowModalContractSettings,
      isContract,
      setShowModalRegisterBookSettings,
      isRegisterBook,
      dispatch,
      DELETE_CODE
    ]
  );

  const closeModalIncidentTypeSettings = () => {    
    setData(initialState);
    setForm(initialState[0]);
    setFilters(initialFilters);
    setApplyFilters(initialFilters);
    setNumTotReg(0);
    setNumTotRegFilter(0);
    setErrorsFilters({});
    setErrors({});
    setInputText("");
    setOpenCreateData(false);
    setOpenDeleteRow(false);
    setOpenEditRow(false);
    setOpenEditFilter(false);
    setRowEdit(initialState[0]);
    dispatch(setLoading(false));
    setIsLoadingError(false);
    setIdCodeDelete(DELETE_CODE);
    setActiveOffset(false);
    setCurrencyOffset(0);
    setRangeOffset([{}]);
    setOpenCreateProvince(false);
    setIndexShowSettings(0);
    setShowModalIncidentTypeSettings(false);
    setShowModalGeneralSettings(true);
    setShowModalEmployeeSettings(isEmployee);
    setShowModalStoreSettings(isStore);
    setShowModalFormSettings(isForm);
    setShowModalContractSettings(isContract);
    setShowModalRegisterBookSettings(isRegisterBook);
  };

  const openCreateOrEditData = () => {
    setInputText("");
    setOpenCreateData(true);
  };

  const openEditFilters = () => {
    setFilters(applyFilters);
    setOpenEditFilter(!openEditFilter);
  };

  const handleSubmitFilterEdit = () => {
    setErrorsFilters(validateFormFilter());
    if (Object.keys(errorsFilters).length === 0) {
      setApplyFilters(filters);
      setFilters(initialFilters);
      setErrorsFilters({});
      setOpenEditFilter(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  
  const handleDeleteFilters = () => {
    setErrorsFilters({});
    setFilters(initialFilters);
    setApplyFilters(initialFilters);
    setOpenEditFilter(!openEditFilter);
  };

  const handleCancelFilters = () => {
    setErrorsFilters({});
    setFilters(initialFilters);
    setOpenEditFilter(!openEditFilter);
  };

  const handleChangeFilterEdit = (e) => {
    const { name, value } = e.target;
    setFilters(filters => ({
      ...filters,
      [name]: value
    }));
  };

  const handleBlurFilterEdit = (e) => {
    setErrorsFilters(validateFormFilter());
    handleChangeFilterEdit(e);
  };

  const toggleDrawerFilterEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      setErrorsFilters({});
      setFilters(initialFilters);
      setOpenEditFilter(!openEditFilter);
    }
  };

  const validateFormFilter = () => {

    let errorsFilters = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filters.idFrom!=="" & !regexNumber.test(filters.idFrom)) {
      errorsFilters.idFrom = 'Text_TextNoNumber';
    }
    if (filters.idTo!=="" & !regexNumber.test(filters.idTo)) {
      errorsFilters.idTo = 'Text_TextNoNumber';
    }
     
    if (filters.idFrom!=="" & !errorsFilters.idFrom!==undefined){
      if (filters.idTo!=="" & !errorsFilters.idTo!==undefined){
        if (parseInt(filters.idTo)<parseInt(filters.idFrom)){
          errorsFilters.idTo = 'Text_TextGreater_Id';
        }
      }
    }
    if (regexInvalidCharacters.test(filters.nameesFrom)) {
      errorsFilters.nameesFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filters.nameesTo)) {
      errorsFilters.nameesTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filters.nameenFrom)) {
      errorsFilters.nameenFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filters.nameenTo)) {
      errorsFilters.nameenTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filters.codeFrom)) {
      errorsFilters.codeFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filters.codeTo)) {
      errorsFilters.codeTo = 'Text_TextNoValid';
    } 
   
    if (filters.nameesTo!=="" & filters.nameesTo<filters.nameesFrom){
      errorsFilters.nameesTo = 'Text_TextGreater_Namees';
    }
    if (filters.nameenTo!=="" & filters.nameenTo<filters.nameenFrom){
      errorsFilters.nameenTo = 'Text_TextGreater_Nameen';
    }
    if (filters.codeTo!=="" & filters.codeTo<filters.codeFrom){
      errorsFilters.codeTo = 'Text_TextGreater_InicidentType';
    }
 
    return errorsFilters;
  }  

  const filteredData = data.filter((el) => {
    if (inputText === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +  
        String(el.namees || '') +   
        String(el.nameen || '') +   
        String(el.code || '');
      let result = dataTranslate.toLowerCase().includes(inputText.toLowerCase());
      return result;
    }
  })
  
  let inputHandler = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };

  const handleChangeDeleteRow = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };

  const handleCancelDeleteRow = () => {
    setErrors({});
    setRowEdit(initialState[0]);
    setForm(initialState[0]);
    dispatch(setLoading(false));
    setIsLoadingError(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
  };

  const handleCloseDeleteRow = (e) => {
    if (idCodeDelete !== DELETE_CODE) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    if (e.key !== 'Escape') {
      if (rowEdit.id !== '') {
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT, `incidenttype/deleteincidenttype`, token, rowEdit);
            if (getData.status === "OK") {
              dispatch(successErrorAction(t('Text_ValidCode')));
              dispatch(successErrorAction(t('Text_DeleteField')));
            } else {
              dispatch(warningErrorAction(t(getData.cause)));
            }
            dispatch(setLoading(false));
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }  
        };
        fetchData();
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    } 
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
    handleCloseDataEdit();
  };
  
  const handleSubmitDataEdit = () => {
    setErrors(validateForm());
    const errorsToCheck = validateForm();
  
    if (Object.keys(errorsToCheck).length === 0 && form.namees !== '' && form.nameen !== '' && form.code !== '') {
      const fetchData = async () => {
        try {
          const getData = openEditRow
            ? await helpHttp().put(ENDPOINT, `incidenttype/updateincidenttype`, token, form)
            : await helpHttp().post(ENDPOINT, `incidenttype/saveincidenttype`, token, form);
          if (getData.status === "OK") {
            dispatch(successErrorAction(t('Text_SaveData')));
            handleCloseDataEdit();
          } else {
            dispatch(warningErrorAction(t(getData.cause)));
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        } 
      };
      fetchData();
    } else {
      if (errorsToCheck.namees) {
        dispatch(warningErrorAction(t(errorsToCheck.namees)));
      } else if (errorsToCheck.nameen) {
        dispatch(warningErrorAction(t(errorsToCheck.nameen)));
      } else if (errorsToCheck.code) {
        dispatch(warningErrorAction(t(errorsToCheck.code)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }
  };

  const handleCloseDataEdit = () => {
    setOpenCreateData(false);
    setOpenEditRow(false);
    setErrors({});
    setRowEdit(openEditRow?rowEdit:initialState[0]);
    setForm(initialState[0]);
    dispatch(setLoading(false));
    setIsLoadingError(false);
    toggleDrawerDataEdit(false);
	};

  const handleChangeDataEdit = (e) => {
    const { name, value } = e.target;
    setForm(form => ({
      ...form,
      [name]: value
    }));
  }; 

  const handleBlurDataEdit = (e) => {
    handleChangeDataEdit(e);
    setErrors(validateForm());
  };
  
  const toggleDrawerDataEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault()
      handleCloseDataEdit();
    }
  };

  const validateForm = () => {
    let errors = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (!form.namees || form.namees==="") {
      errors.namees = 'Text_FieldNameesRequired';
    } else {
      if (regexInvalidCharacters.test(form.namees)) {
        errors.namees = 'Text_TextNoValid';
      }  else{
        if (openEditRow){
          if (data.find((key=>(key.namees.toLowerCase()===form.namees.toLowerCase() && key.id!==rowEdit.id)))) {
            errors.code = 'Text_InicidentType_NameesExist';
          }
        } else {  
          if (data.find((key=>key.namees.toLowerCase()===form.namees.toLowerCase()))) {
            errors.code = 'Text_InicidentType_NameesExist';
          }
        }
      }
    }
    if (!form.nameen || form.nameen==="") {
      errors.nameen = 'Text_FieldNameenRequired';
    } else {
      if (regexInvalidCharacters.test(form.nameen)) {
        errors.nameen = 'Text_TextNoValid';
      } else{
        if (openEditRow){
          if (data.find((key=>(key.nameen.toLowerCase()===form.nameen.toLowerCase() && key.id!==rowEdit.id)))) {
            errors.code = 'Text_InicidentType_NameenExist';
          }
        } else {  
          if (data.find((key=>key.nameen.toLowerCase()===form.nameen.toLowerCase()))) {
            errors.code = 'Text_InicidentType_NameenExist';
          }
        }
      }
    }
    
    if (!form.code || form.code==="") {
      errors.code = 'Text_FieldInicidentTypeRequired';
    } else {
      if (regexInvalidCharacters.test(form.code)) {
        errors.code = 'Text_TextNoValid';
      } else{
        if (openEditRow){
          if (data.find((key=>(key.code.toLowerCase()===form.code.toLowerCase() && key.id!==rowEdit.id)))) {
            errors.code = 'Text_InicidentType_CodeExist';
          }
        } else {  
          if (data.find((key=>key.code.toLowerCase()===form.code.toLowerCase()))) {
            errors.code = 'Text_InicidentType_CodeExist';
          }
        }
      }
    }    
    return errors;
  };

  useEffect(() => {
    setForm(openEditRow ? rowEdit : initialState[0]);
  }, [rowEdit, openEditRow]);
  
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
  useEffect(() => {
    if (numTotRegFilter > LIMIT_PAGE) {
      setActiveOffset(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMIT_PAGE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMIT_PAGE); i < numTotRegFilter; i += Number(LIMIT_PAGE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffset(newRangeOffset);
    } else {
      setCurrencyOffset(0);
      setActiveOffset(false);
      setRangeOffset([{}]);
    }
  }, [numTotRegFilter]);

  useEffect(() => {
    let ignore = false;  
    const fetchnumTotReg = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `incidenttype/getinformationtableincidenttype`, token);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotReg(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
  
    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post(ENDPOINT, `incidenttype/getcountfilterincidenttypes`, token, applyFilters);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
  
    const fetchData = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get3(ENDPOINT, `incidenttype/getincidenttypes`, token, currencyOffset, LIMIT_PAGE, applyFilters);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setData(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
  
    if (showModalIncidentTypeSettings) {
      fetchnumTotReg();
      fetchnumTotRegFilter();
      fetchData();
      return () => { ignore = true; };
    }
  }, [t, token, dispatch, openCreateData, openDeleteRow, openEditRow, rowEdit, showModalIncidentTypeSettings, applyFilters, currencyOffset]);
  return (
    <div> 
      {showModalIncidentTypeSettings && ( 
        <div className="container-fluid formdi-pending-page">
          {/* Search input */}
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingError?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={openDeleteRow?"warning":"primary"}/>:<i className="fas fa-solid fa-clipboard text-warning"></i>} {t('Text_InicidentType_Config')}
            </h1>
              {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Incident_Create'))? (
              <div>
                <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditData} >
                  {t('Button_Create')}
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalIncidentTypeSettings} >
                  {isEmployee ?t("Button_Exit"):t("Button_Back")}
                </button>
              </div>
            ) : (
              <div>
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary" onClick={closeModalIncidentTypeSettings} >
                  {isEmployee ?t("Button_Exit"):t("Button_Back")}
                </button>
              </div>
            )} 
          </div>  
          <br/> 
          {/* Buscador */}
          <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={inputText}
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              placeholder={t('Text_InicidentType_Search')} 
              onChange={inputHandler}
              fullWidth
              label={t('Text_InicidentType_Search')}>
            </TextField>
          </div>
          <br/> 
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${applyFilters.idFrom !== "" || applyFilters.idTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ applyFilters.idFrom !== "" || applyFilters.idTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Code")}
              </button>
              <button type="button" className={`formdi-pending-chip ${applyFilters.codeFrom !== "" || applyFilters.codeTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ applyFilters.codeFrom !== "" || applyFilters.codeTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_InicidentType")}
              </button>
              <button type="button" className={`formdi-pending-chip ${applyFilters.nameesFrom !== "" || applyFilters.nameesTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ applyFilters.nameesFrom !== "" || applyFilters.nameesTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_NameEs")}
              </button>
              <button type="button" className={`formdi-pending-chip ${applyFilters.nameenFrom !== "" || applyFilters.nameenTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ applyFilters.nameenFrom !== "" || applyFilters.nameenTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_NameEn")}
              </button>
            </div>
          </div> 
          <br/>
          <div className="formdi-pending-card-flat">
            <div className="formdi-pending-card-content">
              <TableSorting
                data={filteredData}
                headCells={headCells}
                numTotRegFilter={numTotRegFilter}
                titleTable={t('Text_InicidentType_Table')}
                setOpenDeleteRow={setOpenDeleteRow}
                setOpenEditRow={setOpenEditRow}
                setRowEdit={setRowEdit}
                showEditButton={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Incident_Edit'))?true:false}
                showDeleteButton={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Incident_Delete'))?true:false}
                typeTable={8}
                setOpenCreateProvince={setOpenCreateProvince}
                showVisibilityButton={false}
                numTotReg={numTotReg}
                activeOffset={activeOffset}
                rangeOffset={rangeOffset}
                currencyOffset={currencyOffset}
                setCurrencyOffset={setCurrencyOffset}
                minvalue={Number(NON_ERASABLE_INCIDENTTYPE_ID)}>
              </TableSorting>
            </div>             
          </div>
          {openEditFilter &&
            <div>
              <SwipeableDrawer
                anchor='right'
                open={true}
                onClose={toggleDrawerFilterEdit(false)}
                onOpen={toggleDrawerFilterEdit(true)}>
                <Container >
                  <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850px' }}>
                    <br/>
                    <div id="myDIV">
                      <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                    </div>
                    <hr className="sidebar-divider d-none d-md-block"/>
                    <form className="createfilter" onSubmit={handleCancelFilters}>  
                      <div className="form-floating mb-3 px-4 primary">
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Code_From')} :</label>
                        <div className="form-group">
                          <TextField
                            id="idFrom" 
                            name="idFrom"
                            value={filters.idFrom}
                            inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 15 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                            label={errorsFilters.idFrom!=null?t(errorsFilters.idFrom):t('PlaceHolder_Filter_Code_From')}
                            placeholder={t('PlaceHolder_Filter_Code_From')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Code_To')} :</label>
                        <div className="form-group">
                          <TextField
                            id="idTo" 
                            name="idTo"
                            value={filters.idTo}
                            inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 15 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}   
                            label={errorsFilters.idTo!=null?t(errorsFilters.idTo):t('PlaceHolder_Filter_Code_to')}
                            placeholder={t('PlaceHolder_Filter_Code_to')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_InicidentType_From')} :</label>
                        <div className="form-group">
                          <TextField
                            id="codeFrom" 
                            name="codeFrom"
                            value={filters.codeFrom}
                            inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 5 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsFilters.codeFrom!=null?t(errorsFilters.codeFrom):t('PlaceHolder_Filter_InicidentType_From')}
                            placeholder={t('PlaceHolder_Filter_InicidentType_From')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_InicidentType_To')} :</label>
                        <div className="form-group">
                          <TextField
                            id="codeTo" 
                            name="codeTo"
                            value={filters.codeTo}
                            inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 5 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsFilters.codeTo!=null?t(errorsFilters.codeTo):t('PlaceHolder_FilterInicidentType_to')}
                            placeholder={t('PlaceHolder_FilterInicidentType_to')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_NameEs_From')} :</label>
                        <div className="form-group">
                          <TextField
                            id="nameesFrom" 
                            name="nameesFrom"
                            value={filters.nameesFrom}
                            inputProps={{ style: {width: 800,  fontSize: '18px', }, maxLength: 250 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsFilters.nameesFrom!=null?t(errorsFilters.nameesFrom):t('PlaceHolder_Filter_NameEs_From')}
                            placeholder={t('PlaceHolder_Filter_NameEs_From')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_NameEs_To')} :</label>
                        <div className="form-group">
                          <TextField
                            id="nameesTo" 
                            name="nameesTo"
                            value={filters.nameesTo}
                            inputProps={{ style: {width: 800,  fontSize: '18px', }, maxLength: 250 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsFilters.nameesTo!=null?t(errorsFilters.nameesTo):t('PlaceHolder_Filter_NameEs_to')}
                            placeholder={t('PlaceHolder_Filter_NameEs_to')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>

                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_NameEn_From')} :</label>
                        <div className="form-group">
                          <TextField
                            id="nameenFrom" 
                            name="nameenFrom"
                            value={filters.nameenFrom}
                            inputProps={{ style: {width: 800,  fontSize: '18px', }, maxLength: 250 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                            label={errorsFilters.nameenFrom!=null?t(errorsFilters.nameenFrom):t('PlaceHolder_Filter_NameEn_From')}
                            placeholder={t('PlaceHolder_Filter_NameEn_From')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_NameEn_To')} :</label>
                        <div className="form-group">
                          <TextField
                            id="nameenTo" 
                            name="nameenTo"
                            value={filters.nameenTo}
                            inputProps={{ style: {width: 800,  fontSize: '18px', }, maxLength: 250 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                            label={errorsFilters.nameenTo!=null?t(errorsFilters.nameenTo):t('PlaceHolder_Filter_NameEn_to')}
                            placeholder={t('PlaceHolder_Filter_NameEn_to')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>
                        <hr className="sidebar-divider d-none d-md-block" />
                        <div className="formdi-pending-action-group">
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEdit}>
                            {t('Button_Apply')}
                          </button> 
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFilters}>
                            {t('Button_Cancel_Filters')}
                          </button>
                        </div>  
                      </div>
                    </form>
                  </Box>
                </Container>
              </SwipeableDrawer>
            </div>
          }  
          {(openCreateData || openEditRow)&& 
          <div>
            <SwipeableDrawer
              anchor='right'
              open={true}
              onClose={toggleDrawerDataEdit(false)}
              onOpen={toggleDrawerDataEdit(true)}>
              <Container >
                <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850px' }}>
                  <br/>
                  <div id="myDIV">
                    <h1 className="h1NewStyle px-4 mb-2">{openEditRow?t('Text_InicidentType_Edit'):t('Text_InicidentType_Create')}</h1>
                  </div>  
                  <hr className="sidebar-divider d-none d-md-block"/>
                  <form className="createtreatmenttype" onSubmit={handleSubmitDataEdit}>  
                    <div className="form-floating mb-3 px-4 primary">
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Code')} :</label>
                      <div className="form-group">
                        <TextField
                          id="id" 
                          name="id"
                          value={form.id}
                          inputProps={{ style: {width: 200,  fontSize: '18px', }, maxLength: 15 }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                          label={t('PlaceHolder_InicidentType_Code')}
                          placeholder={t('PlaceHolder_InicidentType_Code')}
                          variant="standard"
                          disabled/>
                      </div>
                     
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_InicidentType')} :</label>
                      <div className="form-group">
                        <TextField
                          id="code" 
                          name="code"
                          value={form.code}
                          inputProps={{ style: {width: 800,  fontSize: '18px', }, maxLength: 5 }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          label={errors.code!=null?t(errors.code):t('PlaceHolder_InicidentType_Code_Enter')}
                          placeholder={t('PlaceHolder_InicidentType_Code_Enter')}
                          variant="standard"
                          onBlur={handleBlurDataEdit}
                          onChange={handleChangeDataEdit}/>
                      </div>

                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NameEs')} :</label>
                      <div className="form-group">
                        <TextField
                          id="namees" 
                          name="namees"
                          value={form.namees}
                          inputProps={{ style: {width: 800,  fontSize: '18px', }, maxLength: 250 }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          label={errors.namees!=null?t(errors.namees):t('PlaceHolder_InicidentType_NameEs')}
                          placeholder={t('PlaceHolder_InicidentType_NameEs')}
                          variant="standard"
                          onBlur={handleBlurDataEdit}
                          onChange={handleChangeDataEdit}/>
                      </div>
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NameEn')} :</label>
                      <div className="form-group">
                        <TextField
                          id="nameen" 
                          name="nameen"
                          value={form.nameen}
                          inputProps={{ style: {width: 800,  fontSize: '18px', }, maxLength: 250 }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                          label={errors.nameen!=null?t(errors.nameen):t('PlaceHolder_InicidentType_NameEn')}
                          placeholder={t('PlaceHolder_InicidentType_NameEn')}
                          variant="standard"
                          onBlur={handleBlurDataEdit}
                          onChange={handleChangeDataEdit}/>
                      </div> 
                      <hr className="sidebar-divider d-none d-md-block" />
                      <div className="formdi-pending-action-group">
                        <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitDataEdit}>
                          {openEditRow?t('Button_Update'):t('Button_Create')}
                        </button> 
                        <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleCloseDataEdit}>
                          {t('Button_Cancel')}
                        </button>
                      </div>  
                    </div>
                  </form>
                </Box>
              </Container>
            </SwipeableDrawer>
          </div>}
          <Dialog open={openDeleteRow} onClose={handleCancelDeleteRow} PaperProps={{ className: "my-dialog-paper-danger" }} >
            <DialogTitle className="my-dialog-title-danger">
              {t('Text_Delete')} {rowEdit.id}  - {rowEdit.code} - {rowEdit.namees} - {rowEdit.nameen}
            </DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText-danger">
                  {t("Text_Line1")}<br />
                  {t("Text_Line2")}
                </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCode"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDelete}
                    onChange={handleChangeDeleteRow}
                  />
                </DialogContent>
              <DialogActions className="my-dialog-actions">
              <Button
                onClick={handleCancelDeleteRow}
                className="my-dialog-button-cancel-danger"
              >
                {t("Button_Cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={handleCloseDeleteRow}
                className="my-dialog-button-delete"
              >
                {t("Button_Delete")}
              </Button>
            </DialogActions>
          </Dialog>  
          {/* End Content Row */}
        </div>
        //* End Page Content *//
      )}
     </div>
  )
}

IncidentTypeSettings.propTypes = {
  showModalIncidentTypeSettings: PropTypes.bool.isRequired,
  setShowModalIncidentTypeSettings: PropTypes.func.isRequired,
  setIndexShowSettings: PropTypes.func.isRequired,
  setShowModalGeneralSettings: PropTypes.func.isRequired,
  setShowModalEmployeeSettings: PropTypes.func.isRequired,
  isEmployee: PropTypes.bool.isRequired,
  setShowModalStoreSettings: PropTypes.func.isRequired,
  isStore: PropTypes.bool.isRequired,
  setShowModalFormSettings: PropTypes.func.isRequired,
  isForm: PropTypes.bool.isRequired,
  setShowModalContractSettings: PropTypes.func.isRequired,
  isContract: PropTypes.bool.isRequired,
  setShowModalRegisterBookSettings: PropTypes.func.isRequired,
  isRegisterBook: PropTypes.bool.isRequired
};

export default IncidentTypeSettings;
